<template>
    <div
        :class="classVideo"
        class="component-video"
    >
        <div class="video-container">
            <video
                :src="data.video.url"
                class="video"
                controls
            ></video>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { ComponentVideoFragment } from '@/graphql/api'

const props = defineProps<{
    data: ComponentVideoFragment
}>()

const classVideo = computed(() => ({
    [`${props.data.videoWidth.replace('_', '-').toLocaleLowerCase()}-width`]:
        true,
}))
</script>

<style lang="scss" scoped>
.component-video {
    width: 100%;

    &.extended-content-width {
        .video-container {
            max-width: 1140px;
            height: auto;
            margin: 0 auto;
        }
    }

    &.content-width {
        .video-container {
            max-width: 680px;
            height: auto;
            margin: 0 auto;
        }
    }

    &.full-width {
        .video-container {
            max-width: 100%;
            height: auto;
            margin: 0 auto;
        }
    }

    .video-container {
        width: 100%;
        margin: 0 auto;

        .video {
            width: 100%;
            aspect-ratio: 16/9;
        }
    }
}
</style>
